import { isLeadUnassigned, leadIsClosed } from "features/LeadGen/pages/LeadAssignments/utils";
import { models } from "types/api/viewModels.ts";

export const countUnassignedOpenLeads = (leads: models["LeadAssignmentViewModel"][]) =>
	leads.filter((lead) => !leadIsClosed(lead.status) && isLeadUnassigned(lead)).length;
